import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";
import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PARTICIPANT_FETCH = "REQUEST_PARTICIPANT_FETCH";
export const doREQUEST_PARTICIPANT_FETCH = createDoRequestAction(REQUEST_PARTICIPANT_FETCH);

export const requestParticipantFetchActionCreators = {
  doREQUEST_PARTICIPANT_FETCH,
};

export function* requestParticipantFetch({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestParticipantFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { participantId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/participant-fetch`,
    accessToken,
    data: {
      participantId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/participant-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* participantFetchSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_FETCH, requestParticipantFetch);
}
